import { render, staticRenderFns } from "./HomePageFeatureMiracleVinyl.vue?vue&type=template&id=7b952c5a&scoped=true&"
import script from "./HomePageFeatureMiracleVinyl.vue?vue&type=script&lang=js&"
export * from "./HomePageFeatureMiracleVinyl.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFeatureMiracleVinyl.vue?vue&type=style&index=0&id=7b952c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b952c5a",
  null
  
)

export default component.exports